import React from "react";
import { Grid, Typography} from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { FeeTooltip } from "./FeeTooltip/FeeTooltip";

const TransferFeeLabel = () => {
  const { offCyclePaymentOptions } = usePartnerConfig();
  const { cycleDpaFeeCents, cycleUserBankFeeCents} = offCyclePaymentOptions;

  return (
    <Grid container alignItems="center">
      <Grid item>
        <Typography>
          Transfer Fee ($):
        </Typography>
      </Grid>
      {
        typeof cycleDpaFeeCents === "number"
          && typeof cycleUserBankFeeCents === "number"
          && cycleDpaFeeCents !== cycleUserBankFeeCents && (
          <Grid item>
            <FeeTooltip
              cycleDpaFeeCents={cycleDpaFeeCents}
              cycleUserBankFeeCents={cycleUserBankFeeCents}
            />
          </Grid>
        )
      }
    </Grid>
  );
};

export default TransferFeeLabel;
